import { render, staticRenderFns } from "./TransferChatModal.vue?vue&type=template&id=46d311cc&scoped=true&"
import script from "./TransferChatModal.vue?vue&type=script&lang=js&"
export * from "./TransferChatModal.vue?vue&type=script&lang=js&"
import style0 from "./TransferChatModal.vue?vue&type=style&index=0&id=46d311cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d311cc",
  null
  
)

export default component.exports